import { render, staticRenderFns } from "./modalAddNews.vue?vue&type=template&id=412699f0&"
import script from "./modalAddNews.vue?vue&type=script&lang=js&"
export * from "./modalAddNews.vue?vue&type=script&lang=js&"
import style0 from "./modalAddNews.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports